import stockService from 'common/services/stockService'
import utils from 'utils'
import canceledInvoiceModule from '../cancelInvoiceModule'
/**
 * 获取盘信息 只校验税号
 * @param  {object} canceledIncoice 已作废发票
 * @return {promise}                发票销方税号是否和盘一致
 */
let checkTaxCode = function checkTaxCode1(canceledIncoice) {
    const deferred = this.$q.defer()
    stockService.getDiskInfo().then((diskInfoStr) => {
        const diskInfo = JSON.parse(diskInfoStr)
        if (!diskInfo.TaxCode) {
            deferred.reject('未启动或未插入金税盘')
        } else if (canceledIncoice.saleCreditCode !== diskInfo.TaxCode) {
            deferred.reject('当前插入设备税号与发票销方税号不一致!')
        } else {
            deferred.resolve(canceledIncoice)
        }
    }, () => {
        deferred.reject('金税盘调用失败')
    })
    return deferred.promise
}
/**
 * 提交重开，生成新的待开
 * 方法给参数添加reopenWaitId字段 对应新的待开waitId
 * @param {object} canceledInvoice 已作废发票
 * @return {promise}     resolve newInvoice 新的待开对象
 */
let submitReopen = function submitReopen1(canceledIncoice) {
    const {
        httpRequest
    } = this
    return httpRequest.post_submitReopenOvatInvoice(canceledIncoice.invoiceId).then(() => httpRequest.post_reopenInvoice(canceledIncoice.invoiceId).then((res) => {
        canceledIncoice.reopenWaitId = res.data.value
        canceledIncoice.waitId = res.data.value
        const newInvoice = {
            waitId: res.data.value,
            invType: canceledIncoice.invType,
            saleCreditCode: canceledIncoice.saleCreditCode,
            ukeyCode: canceledIncoice.ukeyCode,
        }
        return newInvoice
    }))
}
/**
 * 获取库存
 * @param  {object} newInvoice 提交生成的新的待开对象
 * @return {promise}           resolve newInvoice
 */
let checkStock = function checkStock1(newInvoice) {
    const deferred = this.$q.defer()
    window.top.TaxCore.tax.invInfo(newInvoice.invType, (data) => {
        if (data != null) {
            const SIDParam = $.parseJSON(data.value)
            if (SIDParam.retcode === '3011') {
                deferred.resolve(newInvoice)
            } else {
                deferred.reject(SIDParam.retmsg)
            }
        } else {
            logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
        }
    }, newInvoice.saleCreditCode, newInvoice.ukeyCode, 0)
    return deferred.promise
}
/**
 * 锁票
 * @param  {object} newInvoice  提交生成的新的待开对象
 * @return {promise}            resolve newInvoice
 */
let lock = function lock1(newInvoice) {
    const deferred = this.$q.defer()
    this.httpRequest.post_lockOvatInvoiceWait({
        isLock: '1',
        waitId: newInvoice.waitId,
    }).then((ret) => {
        newInvoice.kplsh = ret.data.value;
        deferred.resolve(newInvoice)
    })
    return deferred.promise
}
/**
 * 解锁
 * @param  {object} canceledIncoice 已作废发票对象
 * @return {promise}                resolve canceledIncoice
 */
let unlock = function unlock1(canceledIncoice) {
    const deferred = this.$q.defer()
    this.httpRequest.post_lockOvatInvoiceWait({
        isLock: '0',
        waitId: canceledIncoice.reopenWaitId,
    }).then(() => {
        deferred.resolve(canceledIncoice)
    })
    return deferred.promise
}
/**
 * 后台生成开票报文 返回控制台开票时需要的真实发票对象
 * @param  {object} newInvoice 提交生成的新的待开对象
 * @return {promise}           resolve 控制台开票时需要的真实发票对象
 */
let getRealInvoice = function getRealInvoice1(newInvoice) {
    if (newInvoice.invType === '12') {
        return this.httpRequest.get_queryOvatInvoiceWaitVehicleByIssue({
            waitId: newInvoice.waitId,
        }).then((res) => {
            const realInvoice = res.data.value
            realInvoice.kplsh = newInvoice.kplsh
            realInvoice.invoiceType = realInvoice.infoKind
            return realInvoice
        })
    }
    return this.httpRequest.get_queryOvatInvoiceWaitByIssue({
        waitId: newInvoice.waitId,
    }).then((res) => {
        const realInvoice = res.data.value
        realInvoice.kplsh = newInvoice.kplsh
        realInvoice.waitId = newInvoice.waitId
        return realInvoice
    })
}

/**
 * 回写e税云重开结果
 * @param  {object} canceledIncoice 已作废发票，更新重开状态
 * @param  {number} reopenRet       重开结果 1失败 0成功
 * @return {promise}                回写结果
 */
let writeBackReopenInvoice = function writeBackReopenInvoice1(canceledIncoice, reopenRet) {
    const paramRet = {
        invoiceId: canceledIncoice.invoiceId,
        reopenRet,
        waitId: canceledIncoice.reopenWaitId,
    }
    return this.httpRequest.post_writeBackReopenInvoice(paramRet)
}

/**
 * 调用控制台开票
 * @param  {object} realInvoice     控制台开票时需要的真实发票对象
 * @param  {object} canceledIncoice 已作废发票
 * @return {promise}                开票结果
 */
let open = function open1(realInvoice, canceledIncoice) {
    const deferred = this.$q.defer()
    window.top.TaxCore.tax.inv(realInvoice.invoiceType, realInvoice, (data1) => {
        const SIDParam = $.parseJSON(data1.value)
        // debugger;
        if (SIDParam.retcode === '4011') { // 成功
            canceledIncoice.invoiceCode = SIDParam.InfoTypeCode
            canceledIncoice.invoiceNumber = SIDParam.InfoNumber
            canceledIncoice.kplsh = realInvoice.kplsh;
            deferred.resolve()
        } else {
            this.httpRequest.post_writeOvatInvoiceFailReason({
                reason: SIDParam.retmsg,
                waitId: canceledIncoice.waitId,
            })
            // 开锁
            unlock(canceledIncoice).then(() => {
                writeBackReopenInvoice(canceledIncoice, 1).then().finally(() => {
                    deferred.reject(SIDParam.retmsg)
                })
            })
        }
    }, canceledIncoice.saleCreditCode, canceledIncoice.ukeyCode, 0)
    return deferred.promise
}

/**
 * 控制台查询发票信息 判断是否开具成功
 * @param  {object} canceledIncoice 用到已作废发票的reopenWaitId字段
 * @return {promise}                resolve 查询结果,即控制台保存的发票对象
 */
let queryInvoiceFromDisk = function queryInvoiceFromDisk1(canceledIncoice) {
    const deferred = this.$q.defer()
    const {
        saleCreditCode,
        ukeyCode
    } = canceledIncoice
    // 机动车
    if (canceledIncoice.invType === '12') {
        window.top.TaxCore.tax.VehicleInvInfoDetail(canceledIncoice, (data2) => {
            const SIDParam = data2.retcode ? data2 : $.parseJSON(data2.value)
            if (SIDParam.retcode == 0) {
                SIDParam.waitId = canceledIncoice.reopenWaitId;
                SIDParam.xsdjbh = canceledIncoice.kplsh;
                const diskInvoice = JSON.stringify(SIDParam)
                deferred.resolve(diskInvoice)
            } else {
                deferred.reject(data2.retmsg)
            }
        }, saleCreditCode, ukeyCode, 0)
        return deferred.promise
    }
    // 其他票种
    window.top.TaxCore.tax.QryInvInfoDetail(canceledIncoice,
        (data2) => {
            const SIDParam = data2.retcode ? data2 : $.parseJSON(data2.value)
            if (SIDParam.retcode == 0) {
                SIDParam.waitId = canceledIncoice.reopenWaitId;
                SIDParam.xsdjbh = canceledIncoice.kplsh;
                const result = JSON.stringify(SIDParam)
                deferred.resolve(result)
            } else {
                deferred.reject(data2.retmsg)
            }
        },
        saleCreditCode, ukeyCode, 0,
    )
    return deferred.promise
}

export default class CanceledInvoiceService {
    constructor(httpRequest, $q) {
        this.$q = $q
        this.httpRequest = httpRequest
        checkTaxCode = checkTaxCode.bind(this)
        submitReopen = submitReopen.bind(this)
        checkStock = checkStock.bind(this)
        lock = lock.bind(this)
        unlock = unlock.bind(this)
        getRealInvoice = getRealInvoice.bind(this)
        open = open.bind(this)
        queryInvoiceFromDisk = queryInvoiceFromDisk.bind(this)
        writeBackReopenInvoice = writeBackReopenInvoice.bind(this)
    }

    blankCancel(blankCancelParam) {
        const deferred = this.$q.defer()
        const {
            httpRequest
        } = this
        const {
            promise
        } = deferred
        const obj = {
            sellerBankAccountNr: null,
            invoiceType: blankCancelParam.invType,
            customerName: null,
            customerTaxNr: null,
            customerAddressTel: null,
            memo: null,
            payee: null,
            checker: null,
            issuer: null,
            sellerAddressTel: null,
            listed: false,
            documentNr: null,
            invoiceItems: [],
            customerBankAccountNr: null,
            CheckEWM: 2,
            infoKind: blankCancelParam.invType,
        }
        window.top.TaxCore.tax.inv(blankCancelParam.invType, obj, (data) => {
            const SIDParam = $.parseJSON(data.value)
            if (SIDParam.retcode === '4011') {
                blankCancelParam.invoiceNumber = SIDParam.InfoNumber
                blankCancelParam.invoiceCode = SIDParam.InfoTypeCode
                blankCancelParam.invType = blankCancelParam.invType
                httpRequest.post_blankCancelInvoice(blankCancelParam).then(() => {
                    deferred.resolve(SIDParam)
                }, (error) => {
                    deferred.reject(error)
                })
            } else {
                deferred.reject(SIDParam.retmsg)
            }
        }, '', '', 0)
        return promise
    }

    /**
     * [reopen description]
     * @param  {[type]} canceledInvoice [description]
     * @return {[type]}                 [description]
     */
    reopen(canceledInvoice) {
        const {
            httpRequest
        } = this
        return checkTaxCode(canceledInvoice)
            .then(submitReopen)
            .then(lock)
            .then(getRealInvoice)
            .then((realInvoice) => open(realInvoice, canceledInvoice))
            .then(() => queryInvoiceFromDisk(canceledInvoice))
            .then((diskInvoice) => // diskInvoice盘里的发票  回传e税云
                writeBackReopenInvoice(canceledInvoice, 0).then(() => {
                    if (canceledInvoice.invType === '12') {
                        httpRequest.post_writeBackToVehicleInv(diskInvoice)
                    } else {
                        httpRequest.post_writeBackToInv(diskInvoice)
                    }
                }))
    }

    batchReopen(canceledInvoiceList) {
        const service = this
        const deferred = service.reopenDefered || service.$q.defer()
        service.reopenDefered = deferred
        if (canceledInvoiceList.length === 0) {
            deferred.resolve()
            service.reopenDefered = null
        } else {
            const canceledInvoice = canceledInvoiceList.shift()
            deferred.notify({
                type: 'info',
                invoice: canceledInvoice,
            })
            service.reopen(canceledInvoice).then(() => {
                deferred.notify({
                    type: 'success',
                    invoice: canceledInvoice,
                })
            }, () => {
                deferred.notify({
                    type: 'error',
                    invoice: canceledInvoice,
                })
            }).finally(() => {
                service.batchReopen(canceledInvoiceList)
            })
        }
        return deferred.promise
    }

    // 获取发票
    queryInvoiceStock() {
        const reg = {
            code: /(<CODE>)(.*?)(<\/CODE>)/g,
            categoryCode: /<LBDM>(.*?)<\/LBDM>/g,
            invoiceType: /<FPZL>(.*?)<\/FPZL>/g,
            startNumber: /<QSHM>(.*?)<\/QSHM>/g,
            collectCount: /<FPFS>(.*?)<\/FPFS>/g,
            gmrq: /<GMRQ>(.*?)<\/GMRQ>/g,
            id: /<FPJH>(.*?)<\/FPJH>/g,
        }
        return new Promise((resolve, reject) => {
            stockService.queryInvoiceStock().then((res) => {
                resolve(utils.analysisXml(reg, res).value)
            })
        })
    }
}
CanceledInvoiceService.$inject = ['httpRequest', '$q']
canceledInvoiceModule.service('canceledInvoiceService', CanceledInvoiceService)


// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/service/CanceledInvoiceService.js